// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"773f8c72","173":"6b7e76a2","244":"342f1a26","522":"a845b686","561":"bab257a4","565":"1cd2ca3d","942":"8a87e85e"}[chunkId] + ".chunk.css";
};